import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "TokenSignInContainer" */ './container/TokenSignInContainer')
);
